module.exports = __webpack_public_path__ + "images/topics/states-of-matter/structures_properties.png";